import { AfterViewInit, Component, ViewEncapsulation, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PORT_LIST } from 'src/app/shared/data/port-list';
import { MAKE_LIST } from 'src/app/shared/data/make-list';
import { MF_YEAR_LIST, REG_YEAR_LIST } from 'src/app/shared/data/years-list';
import { MONTH_LIST } from 'src/app/shared/data/month-list';
import { FUEL_LIST } from 'src/app/shared/data/fuel-list';
import { COLOR_LIST } from 'src/app/shared/data/color-list';

import { STOCK_CHARGES_LIST } from 'src/app/shared/data/charges-list';
import { Vehicle, Charge } from '../proforma.model';
import { CompanyService } from 'src/app/services/company/company.service';
import { PortService } from 'src/app/services/port/port.service';
import { GeneralService } from 'src/app/services/general/general.service';
import { GlobalStateService } from 'src/app/services/global/global-state.service';
import { CarService } from 'src/app/services/car/car.service';
import { OrderService } from 'src/app/services/order/order.service';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { Router } from '@angular/router';
import { InvoiceChargesService } from 'src/app/services/invoice-charges/invoice-charges.service';

declare var Swal: any;

interface Item {
  description: string;
  quantity: number;
  currency: string;
  amount: number;
}

@Component({
  selector: 'app-proforma-add-new',
  templateUrl: './proforma-add-new.component.html',
  styleUrls: ['./proforma-add-new.component.scss'],
  encapsulation: ViewEncapsulation.None
})




export class ProformaAddNewComponent extends DestructorComponent implements OnInit, AfterViewInit {

  countryList: any[] = [];
  portList = PORT_LIST;
  toPortList: any[] = []; // Dynamic port list based on selected country
  maketList: any[] = []; // Will be populated from API
  mfYearsList = MF_YEAR_LIST;
  regYearsList = REG_YEAR_LIST;
  mfMonthList = MONTH_LIST;
  regMonthList = MONTH_LIST;
  fueltList: any = [];
  extColortList = COLOR_LIST;



  items: Item[] = [];
  vehicles: Vehicle[] = [];
  charges: Charge[] = [];

  currencyList = ['USD', 'JPY'];

  chargesList = STOCK_CHARGES_LIST;

  // Form Group
  proformaForm: FormGroup;

  // Company search properties
  companySearchTerm: string = '';
  companySearchResults: any[] = [];
  isCompanySearching: boolean = false;
  showCompanyDropdown: boolean = false;
  selectedCompany: any = null;
  private companySearchSubject = new Subject<string>();

  // Make search properties
  makeSearchTerms: { [key: number]: string } = {};
  makeSearchResults: { [key: number]: any[] } = {};
  isMakeSearching: { [key: number]: boolean } = {};
  showMakeDropdown: { [key: number]: boolean } = {};
  selectedMakes: { [key: number]: any } = {};
  private makeSearchSubjects: { [key: number]: Subject<string> } = {};

  // Model search properties
  modelSearchTerms: { [key: number]: string } = {};
  modelSearchResults: { [key: number]: any[] } = {};
  isModelSearching: { [key: number]: boolean } = {};
  showModelDropdown: { [key: number]: boolean } = {};
  selectedModels: { [key: number]: any } = {};
  private modelSearchSubjects: { [key: number]: Subject<string> } = {};
  modelLists: { [key: number]: any[] } = {}; // Store models for each vehicle by make

  // Car data fetching properties
  isLoadingCarData: { [key: number]: boolean } = {};
  carDataLoadError: { [key: number]: string } = {};

  // Item description properties
  isDescriptionAutoGenerated: boolean = false;

  // Form submission tracking
  isFormSubmitted: boolean = false;
  isLoading: boolean = false;

  // Current vehicle index for modal operations
  currentVehicleIndex: number = 0;

  // Consignee modal properties
  selectedCompanyForConsignee: any = null;
  selectedCompanyName: string = '';

  // Company currency type
  selectedCompanyCurrencyType: string = 'USD';

  constructor(
    private _companyService: CompanyService,
    private _portService: PortService,
    private _generalService: GeneralService,
    private _globalStateService: GlobalStateService,
    private _carService: CarService,
    private _orderService: OrderService,
    private _router: Router,
    private _invoiceChargeService: InvoiceChargesService,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef
  ) {
    super();
    this.setupCompanySearchDebounce();
    this.initializeForm();
  }

  ngOnInit(): void {
    // Subscribe to countries from GlobalStateService
    this.subscriptions.push(
      this._globalStateService.GetCountries().subscribe(countries => {
        this.countryList = countries || [];
        console.log('Countries loaded in proforma:', this.countryList);
      })
    );

    // Subscribe to settings from GlobalStateService to auto-populate shipper information
    this.subscriptions.push(
      this._globalStateService.GetSetting().subscribe(setting => {
        if (setting && setting.contacts && setting.contacts.english) {
          this.autoPopulateShipperInformation(setting.contacts.english);
          console.log('Settings loaded and shipper information auto-populated:', setting.contacts.english);
          this.fueltList = setting.fuel_types;
        }
      })
    );

    // Load makes from API
    this.loadMakes();
    this.getInvoiceCharges();

    // Initialize notify party field validators based on checkbox state
    this.onSameAsConsigneeChange();
  }

  private getInvoiceCharges(){
    this.subscriptions.push(
      this._invoiceChargeService.GetData('1', '', {paginate: false}).subscribe({
        next: (response: any) => {
          if (response.status && response.data) {
            this.chargesList = response.data || [];
          } else {
            this.chargesList = [];
          }
        },
        error: (error: any) => {
          console.error('Error loading invoice charges:', error);
          this.chargesList = [];
        }
      })
    );
  }

  private loadMakes(): void {
    this.subscriptions.push(
      this._generalService.GetMakes().subscribe({
        next: (response: any) => {
          if (response.status && response.data) {
            // Map API response to expected format with name as label and slug as value
            this.maketList = response.data.map((make: any) => ({
              value: make.slug || make._id, // Use slug as value, fallback to _id
              label: make.name
            }));
            console.log('Makes loaded from API:', this.maketList);
          } else {
            console.warn('Invalid makes API response:', response);
            // Fallback to static data if API fails
            this.maketList = MAKE_LIST;
          }
        },
        error: (error: any) => {
          console.error('Error loading makes from API:', error);
          // Fallback to static data if API fails
          this.maketList = MAKE_LIST;
        }
      })
    );
  }





  initializeForm(): void {
    this.proformaForm = this.fb.group({
      // Proforma Header - Auto-generated, no validation required
      proformaNumber: [''],
      proformaDate: [''],

      // Buyer Information
      buyerId: [''],
      buyerCompanyName: ['', Validators.required],
      buyerTitle: ['Mr.', Validators.required],
      buyerName: ['', Validators.required],
      buyerAddress: ['', Validators.required],
      buyerCity: ['', Validators.required],
      buyerCountry: ['', Validators.required],
      buyerEmail: ['', [Validators.required, Validators.email]],
      buyerPhone1: ['', Validators.required],
      buyerPhone2: [''],
      sameAsConsignee: [true], // Default to checked

      // Notify Party Information - Only required when sameAsConsignee is false
      notify_party_company: [''],
      notify_party_name: [''],
      notify_party_email: [''],
      notify_party_telephone: [''],
      notify_party_address: [''],
      notify_party_city: [''],
      notify_party_country: [''],

      // Shipper Information - Static/Read-only, no validation required
      shipperCompanyName: [''],
      shipperAddress1: [''],
      shipperAddress2: [''],
      shipperCity: [''],
      shipperState: [''],
      shipperCountry: [''],
      shipperZipCode: [''],
      shipperFax: [''],
      shipperPhone: [''],
      fromCountry: ['109'], // Default Japan
      fromPort: ['17'], // Default ANY PORT IN JAPAN
      toCountry: ['', Validators.required],
      toPort: ['', Validators.required],
      paymentTerms: [''],

      // Additional fields
      discountPercent: [0],
      shipType: ['', Validators.required],
      totalType: ['', Validators.required],
      agentNotes: ['']
    });
  }

  /**
   * Auto-populate shipper information from global settings
   * Maps setting fields to form control names
   * Only populates empty fields to avoid overwriting user input
   */
  autoPopulateShipperInformation(shipperInfo: any): void {
    if (!shipperInfo) return;

    // Get current form values to check which fields are already filled
    const currentFormValues = this.proformaForm.value;

    // Map shipper information fields to form controls
    const shipperFormData: any = {};

    // Map available fields from shipper_information to form fields
    // Only populate if the form field is currently empty
    if (shipperInfo.company && !currentFormValues.shipperCompanyName) {
      shipperFormData.shipperCompanyName = shipperInfo.company;
    }
    if (shipperInfo.address_line_1 && !currentFormValues.shipperAddress1) {
      shipperFormData.shipperAddress1 = shipperInfo.address_line_1;
    }
    if (shipperInfo.address_line_2 && !currentFormValues.shipperAddress2) {
      shipperFormData.shipperAddress2 = shipperInfo.address_2;
    }
    if (shipperInfo.city && !currentFormValues.shipperCity) {
      shipperFormData.shipperCity = shipperInfo.city;
    }
    if (shipperInfo.state && !currentFormValues.shipperState) {
      shipperFormData.shipperState = shipperInfo.state;
    }
    if (shipperInfo.country && !currentFormValues.shipperCountry) {
      shipperFormData.shipperCountry = shipperInfo.country;
    }
    if (shipperInfo.zip && !currentFormValues.shipperZipCode) {
      shipperFormData.shipperZipCode = shipperInfo.zip;
    }
    if (shipperInfo.telephone && !currentFormValues.shipperPhone) {
      shipperFormData.shipperPhone = shipperInfo.telephone;
    }
    if (shipperInfo.payment_terms && !currentFormValues.paymentTerms) {
      shipperFormData.paymentTerms = shipperInfo.payment_terms;
    }

    // Only update the form if there are fields to populate
    if (Object.keys(shipperFormData).length > 0) {
      this.proformaForm.patchValue(shipperFormData);

      console.log('Shipper information auto-populated:', {
        originalData: shipperInfo,
        mappedData: shipperFormData,
        fieldsPopulated: Object.keys(shipperFormData)
      });
    } else {
      console.log('No shipper fields auto-populated (all fields already have values or no matching data)');
    }
  }

  getEmptyVehicle(): Vehicle {
    return {
      selectAll: false,
      stockId: '',
      stockMake: '',
      stockMakeNew: '',
      stockModel: '',
      stockModelNew: '',
      stockModelCode: '',
      stockChassisNo: '',
      stockMFYear: '',
      stockMFMonth: '',
      stockRegYear: '',
      stockInventoryNumber: '',
      stockRegMonth: '',
      stockCarNo: '',
      stockFuel: '',
      stockFuelNew: '',
      stockExteriorColor: '',
      stockExteriorColorNew: '',
      stockSteering: '',
      stockBodyType: '',
      stockHSCode: '',
      stockEngineNo: '',
      stockTransmission: '',
      stockTransmissionNew: '',
      stockMileage: '',
      stockSeatCapacity: '',
      stockAuctionHall: '',
      stockLotNo: '',
      stockOptions: '',
      files: [],
      pictures: []
    };
  }



  addVehicle(): void {
    const vehicle = this.getEmptyVehicle();
    this.vehicles.push(vehicle);

    // Add a new item for this vehicle
    // this.addItem();

    // Update total to recalculate charges based on new vehicle count
    this.updateTotal();
  }

  removeVehicle(index: number): void {
    if (this.vehicles.length > 1) {
      this.vehicles.splice(index, 1);

      // Remove corresponding item if it exists
      if (this.items.length > index && this.items.length > 1) {
        this.removeItem(index);
      }

      // Clean up search data for the removed vehicle
      delete this.makeSearchTerms[index];
      delete this.makeSearchResults[index];
      delete this.isMakeSearching[index];
      delete this.showMakeDropdown[index];
      delete this.selectedMakes[index];
      delete this.makeSearchSubjects[index];

      delete this.modelSearchTerms[index];
      delete this.modelSearchResults[index];
      delete this.isModelSearching[index];
      delete this.showModelDropdown[index];
      delete this.selectedModels[index];
      delete this.modelSearchSubjects[index];
      delete this.modelLists[index];

      // Update total to recalculate charges based on new vehicle count
      this.updateTotal();
    }
  }



  resetVehicle(index: number): void {
    this.vehicles[index] = this.getEmptyVehicle();

    // Clear make and model search data
    this.clearMakeSearch(index);
    this.clearModelSelection(index);
  }

  editVehicle(vehicleId: string): void {
    if (vehicleId) {
      // Navigate to the vehicle edit page in a new tab
      const url = this._router.serializeUrl(
        this._router.createUrlTree(['/vehicles/vehicle-manager/edit', vehicleId])
      );
      window.open(url, '_blank');
    }
  }

  openCarListingModal(vehicleIndex: number): void {
    // Store the current vehicle index for later use when selecting from stock
    this.currentVehicleIndex = vehicleIndex;

    // Open the car listing modal
    const modalElement = document.getElementById('kt_modal_car_listing');
    if (modalElement) {
      const modal = new (window as any).bootstrap.Modal(modalElement);
      modal.show();
    }
  }

  onCarsSelected(selectedCars: any[]): void {
    // Remove the first empty item if it exists and is empty
    if (this.items.length > 0 && this.isItemEmpty(this.items[0])) {
      this.items.splice(0, 1);
      console.log('Removed initial empty item');
    }

    // Remove the first empty vehicle if it exists and is empty
    if (this.vehicles.length > 0 && this.isVehicleEmpty(this.vehicles[0])) {
      this.vehicles.splice(0, 1);
      // Adjust currentVehicleIndex since we removed the first vehicle
      this.currentVehicleIndex = 0;
      console.log('Removed initial empty vehicle');
    }

    // Add selected cars as items to the calculation section
    this.addCarsAsItems(selectedCars);

    // Map selected cars to vehicle sections
    this.mapSelectedCarsToVehicles(selectedCars);

    // Update total after vehicles are mapped to ensure correct vehicle count for charge calculations
    this.updateTotal();
  }

  private mapSelectedCarsToVehicles(selectedCars: any[]): void {
    selectedCars.forEach((car, index) => {
      let targetVehicleIndex = this.currentVehicleIndex + index;

      // Ensure we have enough vehicle sections
      // Add vehicles without adding items (items are already added by addCarsAsItems)
      while (this.vehicles.length <= targetVehicleIndex) {
        const vehicle = this.getEmptyVehicle();
        this.vehicles.push(vehicle);
      }

      // Map the car data to the vehicle using the same logic as the existing implementation
      this.mapCarDataToVehicle(car, targetVehicleIndex);

      // Update make and model search terms to reflect the selected car
      this.updateMakeModelSearchTerms(car, targetVehicleIndex);

      console.log(`Car ${index + 1} mapped to vehicle index ${targetVehicleIndex}`);
    });
  }

  private updateMakeModelSearchTerms(car: any, vehicleIndex: number): void {
    // Update make search term and selection
    if (car.company_name && car.company_slug) {
      this.makeSearchTerms[vehicleIndex] = car.company_name;
      this.selectedMakes[vehicleIndex] = {
        value: car.company_slug,
        label: car.company_name
      };
    }

    // Update model search term and selection
    if (car.name && car.slug) {
      this.modelSearchTerms[vehicleIndex] = car.name;
      this.selectedModels[vehicleIndex] = {
        value: car.slug,
        label: car.name,
        _id: car._id
      };

      // Update vehicle stockId with car ID
      if (this.vehicles[vehicleIndex]) {
        this.vehicles[vehicleIndex].stockId = car._id;
      }
    }

    console.log(`Make/Model search terms updated for vehicle ${vehicleIndex}:`, {
      make: this.makeSearchTerms[vehicleIndex],
      model: this.modelSearchTerms[vehicleIndex]
    });
  }

  private addCarsAsItems(selectedCars: any[]): void {
    // Add each selected car as a regular item in the items array
    selectedCars.forEach(car => {
      const carItem = {
        description: `${car.company_name} ${car.name} (${car.year}) - VIN: ${car.vin_no}`,
        quantity: 1,
        currency: this.selectedCompanyCurrencyType,
        amount: car.price || 0
      };

      this.items.push(carItem);
      console.log('Car added as item:', carItem.description);
    });

    // Note: updateTotal() is called after vehicles are mapped in onCarsSelected()
    // to ensure the correct vehicle count is used for charge calculations

    console.log('Total cars added as items:', selectedCars.length);
  }

  toggleAllProformaFields(vehicleIndex: number): void {
    const vehicle = this.vehicles[vehicleIndex];
    if (!vehicle) return;

    if (vehicle.selectAll) {
      // Fill all fields with placeholder values to make checkboxes checked
      if (!vehicle.stockBodyType) vehicle.stockBodyType = 'N/A';
      if (!vehicle.stockHSCode) vehicle.stockHSCode = 'N/A';
      if (!vehicle.stockTransmission && !vehicle.stockTransmissionNew) vehicle.stockTransmission = 'manual';
      if (!vehicle.stockMileage) vehicle.stockMileage = '0';
      if (!vehicle.stockEngineNo) vehicle.stockEngineNo = 'N/A';
      if (!vehicle.stockSeatCapacity) vehicle.stockSeatCapacity = 'N/A';
      if (!vehicle.stockAuctionHall) vehicle.stockAuctionHall = 'N/A';
      if (!vehicle.stockLotNo) vehicle.stockLotNo = 'N/A';
      if (!vehicle.stockOptions) vehicle.stockOptions = 'N/A';
    } else {
      // Clear all fields to make checkboxes unchecked
      vehicle.stockBodyType = '';
      vehicle.stockHSCode = '';
      vehicle.stockTransmission = '';
      vehicle.stockTransmissionNew = '';
      vehicle.stockMileage = '';
      vehicle.stockEngineNo = '';
      vehicle.stockSeatCapacity = '';
      vehicle.stockAuctionHall = '';
      vehicle.stockLotNo = '';
      vehicle.stockOptions = '';
    }
  }




  formattedTotal = '0';
  formattedFinalTotal = '0';
  discountPercent: number = 0;  // Discount percentage (0 to 100)

  getTotalQuantity(): number {
    return this.items.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
  }

  // Format number without decimals and with commas (for input field display)
  formatNumberWithCommasNoDecimals(num: number): string {
    return Math.round(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // Format number with 2 decimals and commas (for totals)
  formatNumberWithCommas(numStr: string): string {
    const parts = numStr.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (parts.length === 1) parts.push('00'); // Ensure 2 decimals
    if (parts[1].length === 1) parts[1] += '0'; // pad decimals if needed
    return parts.join('.');
  }

  onAmountInput(event: Event, item: any): void {
    const input = event.target as HTMLInputElement;
    // Remove commas and non-digit characters
    let raw = input.value.replace(/,/g, '').replace(/[^0-9]/g, '');
    item.amount = Number(raw) || 0;
    // Show formatted number without decimals in input
    input.value = this.formatNumberWithCommasNoDecimals(item.amount);
    this.updateTotal();
  }

  updateFinalTotal(): void {
    const total = parseFloat(this.formattedTotal.replace(/,/g, '')) || 0;
    const discountAmount = total * (this.discountPercent / 100);
    const final = total - discountAmount;
    this.formattedFinalTotal = this.formatNumberWithCommas(final.toFixed(2));
  }

  updateTotal(): void {
    let total = 0;

    // Calculate total from items
    for (const item of this.items) {
      const qty = Number(item.quantity) || 0;
      const amt = Number(item.amount) || 0;
      total += qty * amt;
    }

    // Add charges multiplied by number of vehicles
    const numberOfVehicles = this.vehicles.length || 1;
    for (const charge of this.charges) {
      const chargeAmount = Number(charge.amount) || 0;
      if (chargeAmount > 0 && charge.charge_type) {
        total += chargeAmount * numberOfVehicles;
      }
    }

    this.formattedTotal = this.formatNumberWithCommas(total.toFixed(2));
    this.updateFinalTotal();
  }

  addItem(): void {
    const newItem = {
      description: '',
      quantity: 1,
      currency: this.selectedCompanyCurrencyType,
      amount: 0
    };
    this.items.push(newItem);
  }

  isItemEmpty(item: Item): boolean {
    // Check if item is empty (no description and amount is 0)
    return (!item.description || item.description.trim() === '') && (item.amount === 0 || !item.amount);
  }

  isVehicleEmpty(vehicle: Vehicle): boolean {
    // Check if vehicle is empty (no make, model, or chassis number)
    return (!vehicle.stockMake || vehicle.stockMake === '') &&
           (!vehicle.stockModel || vehicle.stockModel === '') &&
           (!vehicle.stockChassisNo || vehicle.stockChassisNo === '') &&
           (!vehicle.stockId || vehicle.stockId === '');
  }

  updateExistingItemsCurrency(): void {
    // Update currency for all existing items when company is selected
    this.items.forEach(item => {
      item.currency = this.selectedCompanyCurrencyType;
    });
  }

  removeItem(index: number): void {
    if (this.items.length > 1) {
      this.items.splice(index, 1);
      this.updateTotal();
    }
  }

  // Charge management methods
  addCharge(): void {
    const newCharge: Charge = {
      currency: 'JPY',
      charge_type: '',
      amount: 0
    };
    this.charges.push(newCharge);
  }

  removeCharge(index: number): void {
    if (this.charges.length > 0) {
      this.charges.splice(index, 1);
      // Update total after removing charge
      this.updateTotal();
    }
  }

  onChargeTypeChange(index: number, selectedValue: string): void {
    if (selectedValue && this.charges[index]) {
      const selectedCharge = this.chargesList.find(charge => charge.value === selectedValue);
      if (selectedCharge) {
        this.charges[index].charge_type = selectedCharge.value || selectedCharge.label;
        // Auto-populate amount based on currency if available
        if (this.charges[index].currency === 'JPY' && selectedCharge.jpy) {
          this.charges[index].amount = parseFloat(selectedCharge.jpy) || 0;
        } else if (this.charges[index].currency === 'USD' && selectedCharge.usd) {
          this.charges[index].amount = parseFloat(selectedCharge.usd) || 0;
        }
      }
    } else if (this.charges[index]) {
      // Clear charge type and amount if no selection
      this.charges[index].charge_type = '';
      this.charges[index].amount = 0;
    }

    // Update total to include charges
    this.updateTotal();
  }

  onChargeCurrencyChange(index: number, currency: string): void {
    if (this.charges[index]) {
      this.charges[index].currency = currency;

      // If a charge type is already selected, update the amount based on the new currency
      if (this.charges[index].charge_type) {
        const selectedCharge = this.chargesList.find(charge => charge.value === this.charges[index].charge_type);
        if (selectedCharge) {
          if (currency === 'JPY' && selectedCharge.jpy) {
            this.charges[index].amount = parseFloat(selectedCharge.jpy) || 0;
          } else if (currency === 'USD' && selectedCharge.usd) {
            this.charges[index].amount = parseFloat(selectedCharge.usd) || 0;
          } else {
            // If the selected charge doesn't have a value for the new currency, reset to 0
            this.charges[index].amount = 0;
          }
        }
      } else {
        // Reset amount when currency changes and no charge type is selected
        this.charges[index].amount = 0;
      }

      // Update total when currency changes
      this.updateTotal();
    }
  }

  formatPrice(value: string): string {
    const num = Number(value);
    return isNaN(num) ? '' : num.toLocaleString('en-US', { maximumFractionDigits: 0 });
  }

  // Company search methods
  private setupCompanySearchDebounce(): void {
    this.companySearchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(searchTerm => {
      if (searchTerm.length >= 2) {
        this.searchCompanies(searchTerm);
      } else {
        this.companySearchResults = [];
        this.showCompanyDropdown = false;
      }
    });
  }

  onCompanySearchInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.companySearchTerm = target.value;
    this.selectedCompany = null;

    // Update the form control with the typed value
    this.proformaForm.patchValue({
      buyerCompanyName: this.companySearchTerm
    });

    if (this.companySearchTerm.length >= 2) {
      this.companySearchSubject.next(this.companySearchTerm);
      this.showCompanyDropdown = true;
    } else {
      this.showCompanyDropdown = false;
      this.companySearchResults = [];
    }
  }

  private searchCompanies(searchTerm: string): void {
    this.isCompanySearching = true;

    this._companyService.GetData('1', searchTerm).subscribe({
      next: (response: any) => {
        this.isCompanySearching = false;
        if (response.status && response.data && response.data.data) {
          this.companySearchResults = response.data.data;
          this.showCompanyDropdown = this.companySearchResults.length > 0;
        } else {
          this.companySearchResults = [];
          this.showCompanyDropdown = false;
        }
      },
      error: (error: any) => {
        this.isCompanySearching = false;
        console.error('Error searching companies:', error);
        this.companySearchResults = [];
        this.showCompanyDropdown = false;
      }
    });
  }

  selectCompany(company: any): void {
    this.selectedCompany = company;
    const companyName = company.company || company.name || '';
    this.companySearchTerm = companyName;
    this.showCompanyDropdown = false;
    this.companySearchResults = [];

    // Store company currency type for items
    this.selectedCompanyCurrencyType = company.currency_type ? company.currency_type.toUpperCase() : 'USD';

    // Update existing items with new currency type
    this.updateExistingItemsCurrency();

    // Update the form with company name only
    this.proformaForm.patchValue({
      buyerId: company._id || company.id || '',
      buyerCompanyName: companyName
    });

    // Auto-populate destination country and port from selected company
    if (company.country_obj && company.country_obj.code) {
      this.proformaForm.patchValue({
        toCountry: company.country_obj.code
      });

      // Trigger port loading for the selected country
      this.onToCountryChange(company.country_obj.code);

      // Auto-populate port if port_obj exists

    }

    console.log('Company selected, opening consignee modal:', {
      companyId: company._id || company.id || '',
      companyName: companyName,
      currencyType: this.selectedCompanyCurrencyType,
      country: company.country,
      port: company.port_obj
    });

    // Open consignee modal instead of directly populating form
    this.openConsigneeModal(company._id || company.id || '', companyName);
  }

  clearCompanySearch(): void {
    this.companySearchTerm = '';
    this.selectedCompany = null;
    this.showCompanyDropdown = false;
    this.companySearchResults = [];

    // Reset company currency type to default
    this.selectedCompanyCurrencyType = 'USD';

    // Update existing items with default currency
    this.updateExistingItemsCurrency();

    // Reset buyer information fields that were auto-filled from company selection
    this.proformaForm.patchValue({
      buyerId: '',
      buyerCompanyName: '',
      buyerTitle: 'Mr.',
      buyerName: '',
      buyerAddress: '',
      buyerCity: '',
      buyerCountry: '',
      buyerEmail: '',
      buyerPhone1: '',
      buyerPhone2: '',
      // Also clear destination country and port when company is cleared
      toCountry: '',
      toPort: ''
    });

    // Clear the port list as well
    this.toPortList = [];
  }

  onCompanyInputFocus(): void {
    if (this.companySearchResults.length > 0) {
      this.showCompanyDropdown = true;
    }
  }

  onCompanyInputBlur(): void {
    // Delay hiding dropdown to allow for click events
    setTimeout(() => {
      this.showCompanyDropdown = false;
    }, 200);
  }

  // Consignee modal methods
  openConsigneeModal(companyId: string, companyName: string): void {
    this.selectedCompanyForConsignee = { _id: companyId };
    this.selectedCompanyName = companyName;

    // Open the consignee modal
    const modalElement = document.getElementById('kt_modal_consignee_list');
    if (modalElement) {
      const modal = new (window as any).bootstrap.Modal(modalElement);
      modal.show();
    }
  }

  onConsigneeSelected(consignee: any): void {
    console.log('Consignee selected:', consignee);

    // Auto-populate buyer information fields with consignee data
    this.proformaForm.patchValue({
      buyerTitle: 'Mr.', // Default title
      buyerName: consignee.name || '',
      buyerAddress: consignee.address || '',
      buyerCity: consignee.city || '',
      buyerCountry: consignee.country || '',
      buyerEmail: consignee.email || '',
      buyerPhone1: consignee.telephone || '',
      buyerPhone2: '' // Clear secondary phone
    });

    console.log('Buyer form fields auto-populated with consignee data:', {
      consigneeName: consignee.name,
      formValue: this.proformaForm.value
    });
  }

  onSameAsConsigneeChange(): void {
    const sameAsConsignee = this.proformaForm.get('sameAsConsignee')?.value;

    if (sameAsConsignee) {
      // Clear notify party fields and remove validators
      this.proformaForm.patchValue({
        notify_party_company: '',
        notify_party_name: '',
        notify_party_email: '',
        notify_party_telephone: '',
        notify_party_address: '',
        notify_party_city: '',
        notify_party_country: ''
      });

      // Remove validators for notify party fields
      this.proformaForm.get('notify_party_company')?.clearValidators();
      this.proformaForm.get('notify_party_name')?.clearValidators();
      this.proformaForm.get('notify_party_email')?.clearValidators();
      this.proformaForm.get('notify_party_telephone')?.clearValidators();
      this.proformaForm.get('notify_party_address')?.clearValidators();
      this.proformaForm.get('notify_party_city')?.clearValidators();
      this.proformaForm.get('notify_party_country')?.clearValidators();
    } else {
      // Add validators for notify party fields when checkbox is unchecked
      this.proformaForm.get('notify_party_company')?.setValidators([Validators.required]);
      this.proformaForm.get('notify_party_name')?.setValidators([Validators.required]);
      this.proformaForm.get('notify_party_email')?.setValidators([Validators.required, Validators.email]);
      this.proformaForm.get('notify_party_telephone')?.setValidators([Validators.required]);
      this.proformaForm.get('notify_party_address')?.setValidators([Validators.required]);
      this.proformaForm.get('notify_party_city')?.setValidators([Validators.required]);
      this.proformaForm.get('notify_party_country')?.setValidators([Validators.required]);
    }

    // Update validity for all notify party fields
    this.proformaForm.get('notify_party_company')?.updateValueAndValidity();
    this.proformaForm.get('notify_party_name')?.updateValueAndValidity();
    this.proformaForm.get('notify_party_email')?.updateValueAndValidity();
    this.proformaForm.get('notify_party_telephone')?.updateValueAndValidity();
    this.proformaForm.get('notify_party_address')?.updateValueAndValidity();
    this.proformaForm.get('notify_party_city')?.updateValueAndValidity();
    this.proformaForm.get('notify_party_country')?.updateValueAndValidity();
  }

  // Make search methods
  private setupMakeSearchDebounce(vehicleIndex: number): void {
    if (!this.makeSearchSubjects[vehicleIndex]) {
      this.makeSearchSubjects[vehicleIndex] = new Subject<string>();
      this.makeSearchSubjects[vehicleIndex].pipe(
        debounceTime(300),
        distinctUntilChanged()
      ).subscribe(searchTerm => {
        if (searchTerm.length >= 1) {
          this.searchMakes(vehicleIndex, searchTerm);
        } else {
          // Show all makes when search term is empty
          this.makeSearchResults[vehicleIndex] = [...this.maketList];
          this.showMakeDropdown[vehicleIndex] = this.makeSearchResults[vehicleIndex].length > 0;
        }
      });
    }
  }

  onMakeSearchInput(event: Event, vehicleIndex: number): void {
    const target = event.target as HTMLInputElement;
    this.makeSearchTerms[vehicleIndex] = target.value;
    this.selectedMakes[vehicleIndex] = null;

    // Setup debounce for this vehicle if not already done
    this.setupMakeSearchDebounce(vehicleIndex);

    // Always trigger search, even for empty strings
    this.makeSearchSubjects[vehicleIndex].next(this.makeSearchTerms[vehicleIndex]);
    this.showMakeDropdown[vehicleIndex] = true;
  }

  private searchMakes(vehicleIndex: number, searchTerm: string): void {
    this.isMakeSearching[vehicleIndex] = true;

    // Filter makes locally since we have all makes loaded
    const filteredMakes = this.maketList.filter(make =>
      make.label.toLowerCase().includes(searchTerm.toLowerCase())
    );

    this.isMakeSearching[vehicleIndex] = false;
    this.makeSearchResults[vehicleIndex] = filteredMakes;
    this.showMakeDropdown[vehicleIndex] = filteredMakes.length > 0;
  }

  selectMake(make: any, vehicleIndex: number): void {
    this.selectedMakes[vehicleIndex] = make;
    this.makeSearchTerms[vehicleIndex] = make.label;
    this.showMakeDropdown[vehicleIndex] = false;
    this.makeSearchResults[vehicleIndex] = [];

    // Update the vehicle's make value
    if (this.vehicles[vehicleIndex]) {
      this.vehicles[vehicleIndex].stockMake = make.value;
    }

    // Clear previous model selection and load models for the selected make
    this.clearModelSelection(vehicleIndex);
    this.loadModelsForMake(make.value, vehicleIndex);
  }

  clearMakeSearch(vehicleIndex: number): void {
    this.makeSearchTerms[vehicleIndex] = '';
    this.selectedMakes[vehicleIndex] = null;
    this.showMakeDropdown[vehicleIndex] = false;
    this.makeSearchResults[vehicleIndex] = [];

    // Clear the vehicle's make value
    if (this.vehicles[vehicleIndex]) {
      this.vehicles[vehicleIndex].stockMake = '';
    }

    // Clear model selection when make is cleared
    this.clearModelSelection(vehicleIndex);

    // Reset all stock information when make is cleared
    this.resetStockInformation(vehicleIndex);
  }

  onMakeInputFocus(vehicleIndex: number): void {
    // Show all makes when input is focused (clicked)
    if (!this.makeSearchTerms[vehicleIndex] || this.makeSearchTerms[vehicleIndex].trim() === '') {
      // Show all makes if no search term
      this.makeSearchResults[vehicleIndex] = [...this.maketList];
    } else if (this.makeSearchResults[vehicleIndex] && this.makeSearchResults[vehicleIndex].length > 0) {
      // Show existing search results if there's a search term
    } else {
      // Filter makes based on current search term
      this.makeSearchResults[vehicleIndex] = this.maketList.filter(make =>
        make.label.toLowerCase().includes(this.makeSearchTerms[vehicleIndex].toLowerCase())
      );
    }

    this.showMakeDropdown[vehicleIndex] = this.makeSearchResults[vehicleIndex].length > 0;
  }

  onMakeInputBlur(vehicleIndex: number): void {
    // Delay hiding dropdown to allow for click events
    setTimeout(() => {
      this.showMakeDropdown[vehicleIndex] = false;
    }, 200);
  }

  // Model-related methods
  private loadModelsForMake(makeSlug: string, vehicleIndex: number): void {
    if (!makeSlug) {
      this.modelLists[vehicleIndex] = [];
      return;
    }

    this.subscriptions.push(
      this._generalService.GetModels(makeSlug).subscribe({
        next: (response: any) => {
          if (response.status && response.data) {
            // Map API response to expected format with name as label and slug as value, but keep _id for stockId
            this.modelLists[vehicleIndex] = response.data.map((model: any) => ({
              value: model.slug || model._id, // Use slug as value, fallback to _id
              label: model.name,
              _id: model._id, // Keep _id for stockId
              id: model.id // Keep id as fallback
            }));
            console.log(`Models loaded for make ${makeSlug}:`, this.modelLists[vehicleIndex]);
          } else {
            console.warn('Invalid models API response:', response);
            this.modelLists[vehicleIndex] = [];
          }
        },
        error: (error: any) => {
          console.error('Error loading models from API:', error);
          this.modelLists[vehicleIndex] = [];
        }
      })
    );
  }

  private clearModelSelection(vehicleIndex: number): void {
    this.modelSearchTerms[vehicleIndex] = '';
    this.selectedModels[vehicleIndex] = null;
    this.showModelDropdown[vehicleIndex] = false;
    this.modelSearchResults[vehicleIndex] = [];
    this.modelLists[vehicleIndex] = [];

    // Clear the vehicle's model value and stockId
    if (this.vehicles[vehicleIndex]) {
      this.vehicles[vehicleIndex].stockModel = '';
      this.vehicles[vehicleIndex].stockId = '';
    }

    // Reset all stock information when model selection is cleared
    this.resetStockInformation(vehicleIndex);
  }

  private setupModelSearchDebounce(vehicleIndex: number): void {
    if (!this.modelSearchSubjects[vehicleIndex]) {
      this.modelSearchSubjects[vehicleIndex] = new Subject<string>();
      this.modelSearchSubjects[vehicleIndex].pipe(
        debounceTime(300),
        distinctUntilChanged()
      ).subscribe(searchTerm => {
        if (searchTerm.length >= 1) {
          this.searchModels(vehicleIndex, searchTerm);
        } else {
          // Show all models when search term is empty
          this.modelSearchResults[vehicleIndex] = [...(this.modelLists[vehicleIndex] || [])];
          this.showModelDropdown[vehicleIndex] = this.modelSearchResults[vehicleIndex].length > 0;
        }
      });
    }
  }

  onModelSearchInput(event: Event, vehicleIndex: number): void {
    const target = event.target as HTMLInputElement;
    this.modelSearchTerms[vehicleIndex] = target.value;
    this.selectedModels[vehicleIndex] = null;

    // Setup debounce for this vehicle if not already done
    this.setupModelSearchDebounce(vehicleIndex);

    // Always trigger search, even for empty strings
    this.modelSearchSubjects[vehicleIndex].next(this.modelSearchTerms[vehicleIndex]);
    this.showModelDropdown[vehicleIndex] = true;
  }

  private searchModels(vehicleIndex: number, searchTerm: string): void {
    this.isModelSearching[vehicleIndex] = true;

    // Filter models locally since we have all models loaded for the selected make
    const availableModels = this.modelLists[vehicleIndex] || [];
    const filteredModels = availableModels.filter(model =>
      model.label.toLowerCase().includes(searchTerm.toLowerCase())
    );

    this.isModelSearching[vehicleIndex] = false;
    this.modelSearchResults[vehicleIndex] = filteredModels;
    this.showModelDropdown[vehicleIndex] = filteredModels.length > 0;
  }

  selectModel(model: any, vehicleIndex: number): void {
    this.selectedModels[vehicleIndex] = model;
    this.modelSearchTerms[vehicleIndex] = model.label;
    this.showModelDropdown[vehicleIndex] = false;
    this.modelSearchResults[vehicleIndex] = [];

    // Clear any previous error messages
    this.carDataLoadError[vehicleIndex] = '';

    // Update the vehicle's model value and stockId
    if (this.vehicles[vehicleIndex]) {
      this.vehicles[vehicleIndex].stockModel = model.value;
      this.vehicles[vehicleIndex].stockId = model._id || model.id || ''; // Use model _id as stockId
    }

    // Update item description with make and model
    this.updateItemDescription(vehicleIndex);

    // Fetch car data by model slug
    this.fetchCarDataBySlug(model.value, vehicleIndex);
  }

  clearModelSearch(vehicleIndex: number): void {
    this.modelSearchTerms[vehicleIndex] = '';
    this.selectedModels[vehicleIndex] = null;
    this.showModelDropdown[vehicleIndex] = false;
    this.modelSearchResults[vehicleIndex] = [];
    this.carDataLoadError[vehicleIndex] = '';

    // Clear the vehicle's model value and stockId
    if (this.vehicles[vehicleIndex]) {
      this.vehicles[vehicleIndex].stockModel = '';
      this.vehicles[vehicleIndex].stockId = '';
    }

    // Reset all stock information when model is cleared
    this.resetStockInformation(vehicleIndex);
  }

  resetStockInformation(vehicleIndex: number): void {
    if (!this.vehicles[vehicleIndex]) {
      return;
    }

    const vehicle = this.vehicles[vehicleIndex];

    // Reset all stock information fields that were populated from car data
    vehicle.stockId = '';
    vehicle.stockChassisNo = '';
    vehicle.stockMFYear = '';
    vehicle.stockRegYear = '';
    vehicle.stockMFMonth = '';
    vehicle.stockRegMonth = '';
    vehicle.stockFuel = '';
    vehicle.stockExteriorColor = '';
    vehicle.stockTransmission = '';
    vehicle.stockMileage = '';
    vehicle.stockInventoryNumber = '';

    // Reset additional stock fields
    vehicle.stockBodyType = '';
    vehicle.stockHSCode = '';
    vehicle.stockEngineNo = '';
    vehicle.stockSeatCapacity = '';
    vehicle.stockAuctionHall = '';
    vehicle.stockLotNo = '';
    vehicle.stockOptions = '';

    // Reset vehicle pictures
    vehicle.pictures = [];

    // Reset the item description if it was auto-generated
    if (this.isDescriptionAutoGenerated && this.items.length > 0) {
      this.items[0].description = '';
      this.isDescriptionAutoGenerated = false;
    }

    console.log('Stock information reset for vehicle index:', vehicleIndex);
  }

  fetchCarDataBySlug(modelSlug: string, vehicleIndex: number): void {
    this.isLoadingCarData[vehicleIndex] = true;
    this.carDataLoadError[vehicleIndex] = '';

    this.subscriptions.push(
      this._carService.GetDataBySlug(modelSlug).subscribe({
        next: (response: any) => {
          this.isLoadingCarData[vehicleIndex] = false;
          if (response.status && response.data) {
            this.mapCarDataToVehicle(response.data, vehicleIndex);
            console.log('Car data successfully loaded and mapped for model:', modelSlug);
          } else {
            this.carDataLoadError[vehicleIndex] = 'No car data found for this model';
            console.warn('No car data found for model:', modelSlug, response);
          }
        },
        error: (error: any) => {
          this.isLoadingCarData[vehicleIndex] = false;
          this.carDataLoadError[vehicleIndex] = 'Failed to load car data';
          console.error('Error fetching car data for model:', modelSlug, error);
        }
      })
    );
  }

  mapCarDataToVehicle(carData: any, vehicleIndex: number): void {
    if (!this.vehicles[vehicleIndex]) {
      return;
    }

    const vehicle = this.vehicles[vehicleIndex];

    // Map basic car information with safe property access
    // make -> name (already handled in updateMakeModelSearchTerms)
    // model -> company_name (already handled in updateMakeModelSearchTerms)

    // model_code -> model_code_obj?.code
    vehicle.stockModelCode = carData.model_code_obj?.code || '';

    // chassis_no -> vin_no
    vehicle.stockChassisNo = carData.vin_no || carData.chassis_no || '';

    // manufacturing_year -> manufacturing_year
    vehicle.stockMFYear = carData.manufacturing_year ? carData.manufacturing_year.toString() : (carData.year ? carData.year.toString() : '');

    // manufacturing_month -> manufacturing_month
    vehicle.stockMFMonth = carData.manufacturing_month || '';

    // registration_year -> registration_year
    vehicle.stockRegYear = carData.registration_year ? carData.registration_year.toString() : (carData.year ? carData.year.toString() : '');

    // registration_month -> registration_month
    vehicle.stockRegMonth = carData.registration_month || '';

    // fuel -> fuel_type
    vehicle.stockFuel = carData.fuel_type_slug || '';

    // exterior_color -> exterior_color
    vehicle.stockExteriorColor = carData.exterior_color || carData.color || '';

    // steering -> steering
    vehicle.stockSteering = carData.steering || '';

    // body_type -> body_type_obj.name
    vehicle.stockBodyType = carData.body_type_obj?.name || carData.body_type || '';

    // hs_code -> hs_code
    vehicle.stockHSCode = carData.hs_code || '';

    // transmission -> transmission
    vehicle.stockTransmission = carData.transmission_slug || '';

    // mileage -> mileage
    vehicle.stockMileage = carData.mileage ? carData.mileage.toString() : '';

    // engine_no -> engine_number (prioritize engine_number over engine_no or engine)
    vehicle.stockEngineNo = carData.engine_number || carData.engine_no || '';

    // seat_capacity -> seating_capacity
    vehicle.stockSeatCapacity = carData.seating_capacity ? carData.seating_capacity.toString() : '';

    // auction_hall -> hall_name
    vehicle.stockAuctionHall = carData.hall_name || '';

    // stock_lot_no -> car_no
    vehicle.stockLotNo = carData.car_no || '';
    vehicle.stockCarNo = carData.car_no || '';

    // options -> accessories_and_options (object), show the keys which has value 1 as comma separated
    if (carData.accessories_and_options && typeof carData.accessories_and_options === 'object') {
      const options = Object.keys(carData.accessories_and_options)
        .filter(key => carData.accessories_and_options[key] === 1)
        .join(', ');
      vehicle.stockOptions = options;
    } else {
      vehicle.stockOptions = '';
    }

    vehicle.stockInventoryNumber = carData.inventory_no || '';

    // Set make information if available
    if (carData.company_slug) {
      vehicle.stockMake = carData.company_slug;
    }

    // Map vehicle pictures
    vehicle.pictures = carData.pictures || [];

    // Update the main item description with make and model names
    this.updateItemDescription(vehicleIndex);

    // Setup scroll listeners for new image containers
    this.setupImageScrollListeners();
  }

  updateProformaItems(carData: any, vehicleIndex: number): void {
    if (!this.vehicles[vehicleIndex]) {
      return;
    }

    const vehicle = this.vehicles[vehicleIndex];

    // Update vehicle fields directly with car data
    if (carData.engine || carData.engine_no) {
      vehicle.stockEngineNo = carData.engine || carData.engine_no;
    }

    if (carData.body_type) {
      vehicle.stockBodyType = carData.body_type;
    }

  }

  updateItemDescription(vehicleIndex: number): void {
    // Get the make and model names
    const selectedMake = this.selectedMakes[vehicleIndex];
    const selectedModel = this.selectedModels[vehicleIndex];

    if (selectedMake && selectedModel) {
      // Create description using make name and model name
      const description = `${selectedMake.label} ${selectedModel.label}`;

      // Update the corresponding item's description (each vehicle has its own item)
      if (this.items.length > vehicleIndex) {
        this.items[vehicleIndex].description = description;
        if (vehicleIndex === 0) {
          this.isDescriptionAutoGenerated = true;
        }
      }

    }
  }

  onModelInputFocus(vehicleIndex: number): void {
    // Show all models when input is focused (clicked)
    if (!this.modelSearchTerms[vehicleIndex] || this.modelSearchTerms[vehicleIndex].trim() === '') {
      // Show all models if no search term
      this.modelSearchResults[vehicleIndex] = [...(this.modelLists[vehicleIndex] || [])];
    } else if (this.modelSearchResults[vehicleIndex] && this.modelSearchResults[vehicleIndex].length > 0) {
      // Show existing search results if there's a search term
    } else {
      // Filter models based on current search term
      const availableModels = this.modelLists[vehicleIndex] || [];
      this.modelSearchResults[vehicleIndex] = availableModels.filter(model =>
        model.label.toLowerCase().includes(this.modelSearchTerms[vehicleIndex].toLowerCase())
      );
    }

    this.showModelDropdown[vehicleIndex] = this.modelSearchResults[vehicleIndex].length > 0;
  }

  onModelInputBlur(vehicleIndex: number): void {
    // Delay hiding dropdown to allow for click events
    setTimeout(() => {
      this.showModelDropdown[vehicleIndex] = false;
    }, 200);
  }

  // Port-related methods
  onToCountryChange(countryCode: string): void {
    if (countryCode) {
      // Reset the port selection when country changes
      this.proformaForm.patchValue({ toPort: '' });
      this.toPortList = [];

      // Fetch ports for the selected country
      this.subscriptions.push(
        this._portService.GetData('1', '', { country_code: countryCode, paginate: false }).subscribe({
          next: (response: any) => {
            if (response.status && response.data) {
              // Handle non-paginated response
              this.toPortList = response.data.map((port: any) => ({
                value: port._id,
                label: port.name
              }));

              if (this.selectedCompany && this.selectedCompany.port_obj && this.selectedCompany.port_obj.name) {
                // Set port after a small delay to ensure ports are loaded
                setTimeout(() => {
                  this.proformaForm.patchValue({
                    toPort: this.selectedCompany.port_obj._id
                  });
                }, 500);
              }
            } else {
              this.toPortList = [];
            }
          },
          error: (error: any) => {
            console.error('Error fetching ports:', error);
            this.toPortList = [];
          }
        })
      );
    } else {
      // Clear ports if no country is selected
      this.toPortList = [];
      this.proformaForm.patchValue({ toPort: '' });
    }
  }

  // Form submission
  onSubmit(): void {
    // Set form as submitted to show validation errors
    this.isFormSubmitted = true;

    // Mark all form fields as touched to show validation errors
    this.proformaForm.markAllAsTouched();

    // Validate form, vehicles, and items
    const formValid = this.proformaForm.valid;
    const vehiclesValid = this.validateVehicles();
    const itemsValid = this.validateItems();

    if (formValid && vehiclesValid && itemsValid) {
      const formData = this.proformaForm.value;

      // Transform data according to the required API format
      const apiData = this.transformDataForAPI(formData);

      // Show loading state
      this.isLoading = true;

      // Call OrderService AddData method
      this.subscriptions.push(
        this._orderService.AddData(apiData).subscribe({
          next: (response: any) => {
            this.isLoading = false;
            console.log('Proforma created successfully:', response);

            // Show success message
            Swal.fire({
              text: "Proforma has been successfully created!",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "Ok, got it!",
              customClass: {
                confirmButton: "btn btn-primary"
              }
            }).then((result: any) => {
              if (result.isConfirmed) {
                // Navigate back to proforma list
                this._router.navigate(['/sales/proforma']);
              }
            });
          },
          error: (error: any) => {
            this.isLoading = false;
            console.error('Error creating proforma:', error);

            // Show error message
            Swal.fire({
              text: "Sorry, there was an error creating the proforma. Please try again.",
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Ok, got it!",
              customClass: {
                confirmButton: "btn btn-primary"
              }
            });
          }
        })
      );
    } else {
      // Get all invalid fields and show detailed error information
      const invalidFields = this.getInvalidFields();
      const invalidVehicleFields = this.getInvalidVehicleFields();
      const invalidItemFields = this.getInvalidItemFields();

      const allInvalidFields = [...invalidFields, ...invalidVehicleFields, ...invalidItemFields];
      console.log('Form is invalid. Missing required fields:', allInvalidFields);

      // Show validation error message
      this.showValidationErrorAlert(allInvalidFields);
    }
  }

  private transformDataForAPI(formData: any): any {
    // Transform vehicles data according to API requirements
    const vehicles = this.vehicles.map((vehicle: Vehicle, index: number) => {
      const vehicleData: any = {
        _id: vehicle.stockId || '',
        make: this.selectedMakes[index]?.label || '',
        mileage: parseInt(vehicle.stockMileage || '0') || 0,
        model: this.selectedModels[index]?.label || '',
        year: vehicle.stockMFYear || '',
        reg_year: vehicle.stockRegYear || '',
        inventory_no: vehicle.stockInventoryNumber || '',
        month: this.getMonthName(vehicle.stockMFMonth) || 'january',
        reg_month: this.getMonthName(vehicle.stockRegMonth) || 'january',
        chassis_no: vehicle.stockChassisNo || '',
        car_no: vehicle.stockCarNo || '',
        fuel_type: vehicle.stockFuel || 'petrol',
        engine: vehicle.stockEngineNo || '2500 CC',
        transmission: vehicle.stockTransmission || 'automatic',
        exterior_color: vehicle.stockExteriorColor || 'black',
        body_type: vehicle.stockBodyType || '',
        hs_code: vehicle.stockHSCode || '',
        seat_capacity: vehicle.stockSeatCapacity || '',
        auction_hall: vehicle.stockAuctionHall || '',
        stock_no: vehicle.stockLotNo || '',
        stockOptions: vehicle.stockOptions || '',
        steering: vehicle.stockSteering || ''
      };

      // Add new_fields if any of the "New" fields have values
      if (vehicle.stockMakeNew || vehicle.stockModelNew || vehicle.stockTransmissionNew) {
        vehicleData.new_fields = {
          make: vehicle.stockMakeNew || '',
          model: vehicle.stockModelNew || '',
          transmission: vehicle.stockTransmissionNew || ''
        };
      }

      return vehicleData;
    });

    // Transform items data
    const items = this.items.map(item => ({
      amount: item.amount || 0,
      currency: item.currency || 'JPY',
      description: item.description || '',
      quantity: item.quantity || 1
    }));

    // Transform charges data - only include charges that have both charge_type and amount
    const charges = this.charges
      .filter(charge => charge.charge_type && charge.amount > 0)
      .map(charge => ({
        currency: charge.currency || 'JPY',
        charge_type: charge.charge_type,
        amount: charge.amount || 0
      }));

    // Create the API payload according to the required format
    return {
      buyer_consignee_name: formData.buyerName || '',
      buyer_street_address: formData.buyerAddress || '',
      buyer_city: formData.buyerCity || '',
      buyer_company_name: formData.buyerCompanyName || '',
      buyer_country: formData.buyerCountry || '',
      buyer_title: formData.buyerTitle || 'Mr.',
      buyer_email_address: formData.buyerEmail || '',
      buyer_telephone_no: formData.buyerPhone1 || '',
      buyer_id: formData.buyerId || '',
      from_country: formData.fromCountry || 'JP',
      from_port: formData.fromPort || '',
      to_country: formData.toCountry || '',
      to_port: formData.toPort || '',
      vehicles: vehicles,
      items: items,
      charges: charges,
      discount_percent: formData.discountPercent || 0,
      ship_type: formData.shipType || 'roro',
      total_type: formData.totalType || 'c_and_f',
      agent_notes: formData.agentNotes || '',
      payment_terms: formData.paymentTerms || '',
      same_as_consignee: formData.sameAsConsignee || false,
      notify_party_company: formData.notify_party_company || '',
      notify_party_name: formData.notify_party_name || '',
      notify_party_email: formData.notify_party_email || '',
      notify_party_telephone: formData.notify_party_telephone || '',
      notify_party_address: formData.notify_party_address || '',
      notify_party_city: formData.notify_party_city || '',
      notify_party_country: formData.notify_party_country || ''
    };
  }

  private getMonthName(monthValue: string): string {
    const monthMap: { [key: string]: string } = {
      '1': 'january', '2': 'february', '3': 'march', '4': 'april',
      '5': 'may', '6': 'june', '7': 'july', '8': 'august',
      '9': 'september', '10': 'october', '11': 'november', '12': 'december'
    };
    return monthMap[monthValue] || 'january';
  }

  private showValidationErrorAlert(invalidFields: string[]): void {
    if (invalidFields.length > 0) {
      const message = `Please fill in the following required fields:\n\n• ${invalidFields.join('\n• ')}`;
      Swal.fire({
        text: message,
        icon: "error",
        buttonsStyling: false,
        confirmButtonText: "Ok, got it!",
        customClass: {
          confirmButton: "btn btn-primary"
        }
      });
    } else {
      Swal.fire({
        text: "Please check the form for validation errors.",
        icon: "error",
        buttonsStyling: false,
        confirmButtonText: "Ok, got it!",
        customClass: {
          confirmButton: "btn btn-primary"
        }
      });
    }
  }

  private validateVehicles(): boolean {
    if (this.vehicles.length === 0) {
      return false;
    }

    return this.vehicles.every((vehicle, index) => {
      return this.selectedMakes[index] &&
        this.selectedModels[index] &&
        vehicle.stockChassisNo &&
        vehicle.stockMFYear &&
        vehicle.stockRegYear &&
        vehicle.stockFuel &&
        vehicle.stockExteriorColor;
    });
  }

  private validateItems(): boolean {
    if (this.items.length === 0) {
      return false;
    }

    return this.items.every(item => {
      return item.description &&
        item.quantity &&
        item.currency;
      // Note: amount is optional as per requirements
    });
  }

  private getInvalidFields(): string[] {
    const invalidFields: string[] = [];
    const controls = this.proformaForm.controls;

    // Check each form control
    Object.keys(controls).forEach(key => {
      const control = controls[key];
      if (control.invalid && control.errors) {
        // Map form control names to user-friendly names
        const fieldName = this.getFieldDisplayName(key);
        if (control.errors['required']) {
          invalidFields.push(fieldName);
        }
      }
    });

    return invalidFields;
  }

  private getInvalidVehicleFields(): string[] {
    const invalidFields: string[] = [];

    this.vehicles.forEach((vehicle, index) => {
      const vehiclePrefix = `Vehicle ${index + 1}`;

      if (!this.selectedMakes[index]) {
        invalidFields.push(`${vehiclePrefix} - Make`);
      }
      if (!this.selectedModels[index]) {
        invalidFields.push(`${vehiclePrefix} - Model`);
      }
      if (!vehicle.stockChassisNo) {
        invalidFields.push(`${vehiclePrefix} - Chassis No.`);
      }
      if (!vehicle.stockMFYear) {
        invalidFields.push(`${vehiclePrefix} - Manufacturing Year`);
      }
      if (!vehicle.stockRegYear) {
        invalidFields.push(`${vehiclePrefix} - Registration Year`);
      }
      if (!vehicle.stockFuel) {
        invalidFields.push(`${vehiclePrefix} - Fuel`);
      }
      if (!vehicle.stockExteriorColor) {
        invalidFields.push(`${vehiclePrefix} - Exterior Color`);
      }
    });

    return invalidFields;
  }

  private getInvalidItemFields(): string[] {
    const invalidFields: string[] = [];

    this.items.forEach((item, index) => {
      const itemPrefix = `Item ${index + 1}`;

      if (!item.description) {
        invalidFields.push(`${itemPrefix} - Description`);
      }
      if (!item.quantity) {
        invalidFields.push(`${itemPrefix} - Quantity`);
      }
      if (!item.currency) {
        invalidFields.push(`${itemPrefix} - Currency`);
      }
      // Note: amount is optional as per requirements
    });

    return invalidFields;
  }

  private getFieldDisplayName(controlName: string): string {
    const fieldNames: { [key: string]: string } = {
      'buyerCompanyName': 'Buyer Company Name',
      'buyerTitle': 'Buyer Title',
      'buyerName': 'Buyer Name',
      'buyerAddress': 'Buyer Address',
      'buyerCity': 'Buyer City',
      'buyerCountry': 'Buyer Country',
      'buyerEmail': 'Buyer Email',
      'buyerPhone1': 'Buyer Phone',
      'toCountry': 'To Country',
      'toPort': 'To Port',
      'paymentTerms': 'Payment Terms',
      'shipType': 'Ship Type',
      'totalType': 'Total Type'
    };

    return fieldNames[controlName] || controlName;
  }

  // private showMissingFieldsAlert(invalidFields: string[]): void {
  //   if (invalidFields.length > 0) {
  //     const message = `Please fill in the following required fields:\n\n• ${invalidFields.join('\n• ')}`;
  //     alert(message);
  //   } else {
  //     alert('Please check the form for validation errors.');
  //   }
  // }

  // Image handling methods
  openImageModal(imageUrl: string): void {
    // Open image in a new window/tab for full view
    window.open(imageUrl, '_blank');
  }

  onImageError(event: any): void {
    // Handle image load error by setting a fallback image
    event.target.src = 'assets/media/stock/600x400/img-1.jpg';
  }

  // Helper method to check if vehicle has pictures
  hasVehiclePictures(vehicle: Vehicle): boolean {
    return !!(vehicle && vehicle.pictures && vehicle.pictures.length > 0);
  }

  // Helper method to get vehicle pictures safely
  getVehiclePictures(vehicle: Vehicle): string[] {
    return vehicle?.pictures || [];
  }

  // Image carousel scroll methods
  scrollImages(direction: 'left' | 'right', vehicleIndex: number): void {
    const container = document.getElementById(`imageContainer_${vehicleIndex}`);
    if (!container) return;

    const scrollAmount = 162; // Image width (150px) + gap (12px)
    const currentScroll = container.scrollLeft;

    if (direction === 'left') {
      container.scrollTo({
        left: currentScroll - scrollAmount,
        behavior: 'smooth'
      });
    } else {
      container.scrollTo({
        left: currentScroll + scrollAmount,
        behavior: 'smooth'
      });
    }
  }

  canScrollLeft(vehicleIndex: number): boolean {
    const container = document.getElementById(`imageContainer_${vehicleIndex}`);
    if (!container) return false;
    return container.scrollLeft > 0;
  }

  canScrollRight(vehicleIndex: number): boolean {
    const container = document.getElementById(`imageContainer_${vehicleIndex}`);
    if (!container) return false;
    return container.scrollLeft < (container.scrollWidth - container.clientWidth);
  }

  // Method to setup scroll listeners for image containers
  setupImageScrollListeners(): void {
    // Use setTimeout to ensure DOM is rendered
    setTimeout(() => {
      this.vehicles.forEach((vehicle, index) => {
        if (this.hasVehiclePictures(vehicle)) {
          const container = document.getElementById(`imageContainer_${index}`);
          if (container) {
            // Add scroll event listener to update arrow states
            container.addEventListener('scroll', () => {
              // Trigger change detection to update arrow states
              this.cdr.detectChanges();
            });
          }
        }
      });
    }, 100);
  }

  // Helper methods for template validation display
  isFieldInvalid(fieldName: string): boolean {
    const field = this.proformaForm.get(fieldName);
    return field ? field.invalid && (field.dirty || field.touched || this.isFormSubmitted) : false;
  }

  getFieldError(fieldName: string): string {
    const field = this.proformaForm.get(fieldName);
    if (field && field.errors && (field.dirty || field.touched)) {
      if (field.errors['required']) {
        return `${this.getFieldDisplayName(fieldName)} is required`;
      }
      if (field.errors['email']) {
        return 'Please enter a valid email address';
      }
    }
    return '';
  }

  // Helper methods for vehicle validation
  isVehicleFieldInvalid(vehicleIndex: number, fieldName: string): boolean {
    if (!this.isFormSubmitted) return false;

    switch (fieldName) {
      case 'make':
        return !this.selectedMakes[vehicleIndex];
      case 'model':
        return !this.selectedModels[vehicleIndex];
      case 'chassisNo':
        return !this.vehicles[vehicleIndex]?.stockChassisNo;
      case 'mfYear':
        return !this.vehicles[vehicleIndex]?.stockMFYear;
      case 'regYear':
        return !this.vehicles[vehicleIndex]?.stockRegYear;
      case 'fuel':
        return !this.vehicles[vehicleIndex]?.stockFuel;
      case 'exteriorColor':
        return !this.vehicles[vehicleIndex]?.stockExteriorColor;
      default:
        return false;
    }
  }

  // Helper methods for item validation
  isItemFieldInvalid(itemIndex: number, fieldName: string): boolean {
    if (!this.isFormSubmitted) return false;

    const item = this.items[itemIndex];
    if (!item) return false;

    switch (fieldName) {
      case 'description':
        return !item.description;
      case 'quantity':
        return !item.quantity || item.quantity <= 0;
      case 'currency':
        return !item.currency;
      default:
        return false;
    }
  }

  ngAfterViewInit(): void {
    // Initialize with one vehicle and one item
    const vehicle = this.getEmptyVehicle();
    this.vehicles.push(vehicle);

    // Add initial item with default currency (will be updated when company is selected)
    this.addItem();

    // Initialize with 4 empty charges (as shown in the original HTML)
    for (let i = 0; i < 4; i++) {
      this.addCharge();
    }

    // Setup scroll listeners for image containers
    this.setupImageScrollListeners();

    // Manually trigger change detection to avoid ExpressionChangedAfterItHasBeenCheckedError
    this.cdr.detectChanges();
  }
}
